<!-- <div class="pd-dialog-delete" (click)="$event.stopPropagation()">
    <div class="dialogboxheader">
      <div class="flex-box header-title">
        <h1 mat-dialog-title dialogbox class="flex-box no-marg">
                    <i class="fa-regular fa-triangle-exclamation warning-msg"></i>
          <span>Delete Lead Sheet</span>
        </h1>
      </div>
      <button class="transparent-btn float-right " [mat-dialog-close]>
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>
    <div class="delete-content">
      <p class="dialogbox">You are trying to delete Lead Sheet {{modalData.lsCode}}.</p>
      <p class="dialogbox">Do you want to continue?</p>
    </div>
    <div mat-dialog-actions>
      <div class="pd-delete-dialog-actions unap-yes-no">
        <button mat-flat-button mat-stroked-button class="float-left yesno-btn mar-r-16" color="secondary" [mat-dialog-close]
                (click)="onCloseCancel()">No</button>
        <button mat-flat-button class="float-right yesno-btn" color="primary" [mat-dialog-close]
                (click)="onCloseConfirm()">
          Yes
        </button>
      </div>
    </div>
  </div> -->

  <div class="countable-dialog" (click)="$event.stopPropagation()" style="width: 400px;">
    <div class="dialog-header d-flex flex-column align-items-center">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.5 1.5H11.5M1.5 4H16.5M14.8333 4L14.2489 12.7661C14.1612 14.0813 14.1174 14.7389 13.8333 15.2375C13.5833 15.6765 13.206 16.0294 12.7514 16.2497C12.235 16.5 11.5759 16.5 10.2578 16.5H7.74221C6.42409 16.5 5.76503 16.5 5.24861 16.2497C4.79396 16.0294 4.41674 15.6765 4.16665 15.2375C3.88259 14.7389 3.83875 14.0813 3.75107 12.7661L3.16667 4M7.33333 7.75V11.9167M10.6667 7.75V11.9167" stroke="#D92D20" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
    </div>
    <div class="content dialog-body-content text-center gap-8">
      <h4 class="title text-center">
        Delete Lead Sheet
      </h4>

      <p class="para-text">You are trying to delete Lead Sheet {{modalData.lsCode}}.</p>
      <p class="para-text">Do you want to continue?</p>

    </div>
    <div mat-dialog-actions class="dialog-footer button-group w-100" (click)="$event.stopPropagation()">
        <button mat-button mat-stroked-button class="button-normal flex-1" color="dark" [mat-dialog-close] (click)="onCloseCancel()">Cancel</button>
        <button mat-button mat-flat-button class="button-normal flex-1 m-0" color="error" [mat-dialog-close] (click)="onCloseConfirm()">Delete</button>
    </div>
  </div>
